// src/components/PendingApproval.jsx
import { useState, useEffect } from 'react';
import supabase from '../utils/supabaseClient';

export default function PendingApproval({ status }) {
  const [checking, setChecking] = useState(false);

  // Poll every 10 seconds — when admin approves, user gets in automatically
  useEffect(() => {
    if (status === 'rejected') return;
    const interval = setInterval(async () => {
      // Refresh session to get latest metadata
      const { data: { session } } = await supabase.auth.refreshSession();
      if (session?.user?.user_metadata?.status === 'active') {
        window.location.reload();
      }
    }, 10000);
    return () => clearInterval(interval);
  }, [status]);

  async function handleCheckNow() {
    setChecking(true);
    const { data: { session } } = await supabase.auth.refreshSession();
    if (session?.user?.user_metadata?.status === 'active') {
      window.location.reload();
    } else {
      setChecking(false);
    }
  }

  async function handleSignOut() {
    await supabase.auth.signOut();
  }

  const rejected = status === 'rejected';

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f1f3d 0%, #1a3260 60%, #0f1f3d 100%)',
      fontFamily: 'Inter, system-ui, sans-serif', padding: 20,
    }}>
      <div style={{ width: '100%', maxWidth: 440, textAlign: 'center' }}>

        {/* Logo */}
        <div style={{
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          width: 64, height: 64, borderRadius: 16,
          background: 'linear-gradient(135deg, #c49922 0%, #e8c04a 100%)',
          fontSize: 28, fontWeight: 900, color: '#0f1f3d', marginBottom: 20,
          boxShadow: '0 8px 32px rgba(196,153,34,0.4)',
        }}>GS</div>

        <div style={{ color: '#fff', fontSize: 24, fontWeight: 800, marginBottom: 4 }}>
          GoldenScope
        </div>
        <div style={{ color: 'rgba(255,255,255,.4)', fontSize: 13, marginBottom: 32 }}>
          California State Contract Management
        </div>

        <div style={{
          background: '#fff', borderRadius: 16, padding: 36,
          boxShadow: '0 24px 64px rgba(0,0,0,.4)',
        }}>
          {rejected ? (
            <>
              <div style={{ fontSize: 40, marginBottom: 16 }}>⛔</div>
              <h2 style={{ margin: '0 0 12px', fontSize: 20, fontWeight: 700, color: '#dc2626' }}>
                Access Denied
              </h2>
              <p style={{ color: '#64748b', fontSize: 14, lineHeight: 1.6, margin: '0 0 24px' }}>
                Your request to access GoldenScope has been declined. If you believe
                this is an error, please contact your agency administrator or reach
                out to the GoldenScope team.
              </p>
            </>
          ) : (
            <>
              <div style={{ fontSize: 40, marginBottom: 16 }}>⏳</div>
              <h2 style={{ margin: '0 0 12px', fontSize: 20, fontWeight: 700, color: '#0f1f3d' }}>
                Pending Approval
              </h2>
              <p style={{ color: '#64748b', fontSize: 14, lineHeight: 1.6, margin: '0 0 8px' }}>
                Your account has been created and is awaiting approval from the
                GoldenScope administrator.
              </p>
              <p style={{ color: '#64748b', fontSize: 14, lineHeight: 1.6, margin: '0 0 24px' }}>
                You'll receive access once your account has been reviewed.
                This typically happens within one business day.
              </p>
              <div style={{
                padding: '12px 16px', borderRadius: 10,
                background: '#f0fdf4', border: '1px solid #bbf7d0',
                color: '#16a34a', fontSize: 13, marginBottom: 24,
              }}>
                ✓ Your account is registered — no further action needed
              </div>
            </>
          )}

          {!rejected && (
            <button
              onClick={handleCheckNow}
              disabled={checking}
              style={{
                width: '100%', padding: '11px 0', borderRadius: 10, border: 'none',
                background: 'linear-gradient(135deg, #c49922 0%, #e8c04a 100%)',
                color: '#0f1f3d', fontWeight: 700, fontSize: 14,
                cursor: checking ? 'not-allowed' : 'pointer', marginBottom: 10,
                opacity: checking ? .7 : 1,
              }}
            >
              {checking ? 'Checking…' : '↻ Check Approval Status'}
            </button>
          )}
          <button
            onClick={handleSignOut}
            style={{
              width: '100%', padding: '11px 0', borderRadius: 10, border: 'none',
              background: rejected ? '#dc2626' : '#0f1f3d',
              color: '#fff', fontWeight: 600, fontSize: 14,
              cursor: 'pointer',
            }}
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
}
